import { getUserInfo } from '../service/getData'
import { SET_USER_INFO, SET_LOADING } from './mutation-types'

export default {
  loading ({ state, commit }, data) {
    if (!data.text) {
      data.text = state.loading_text
    }
    commit(SET_LOADING, data)
  },

  async getUserInfo ({ state, commit }) {
    var res = await getUserInfo()
    if (res.code === 1) {
      commit(SET_USER_INFO, res.data)
    } else {
      window.localStorage.clear()
      commit(SET_USER_INFO, {})
    }
  }
}
